// 接口 - 商务管理
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const { baseApi } = apiPrefix;

// 保单批量上传
export const businessPolicyUploadTask = (params) => {
  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });

  return post(`${baseApi}/policyQuery/upload`, data, {
    headers: { "Contennt-Type": "multipart/form-data" },
    noValid: true,
  });
}

// 获取任务状态
export const businessPolicyGetTaskStatus = (params) => get(`${baseApi}/policyQuery/status`, params);

// 下载任务结果
export const businessPolicyDownTaskResult = (params) => get(`${baseApi}/policyQuery/download`, params, { responseType: "blob" });
